// Common IANA timezones grouped by region for the Campaign create form.
// Labels show UTC offsets to help users pick quickly.
export const TIMEZONE_GROUPS = [
    {
        region: "North America (US / Canada)",
        zones: [
            { value: "America/Los_Angeles", label: "Los Angeles (PT)" },
            { value: "America/Denver", label: "Denver (MT)" },
            { value: "America/Chicago", label: "Chicago (CT)" },
            { value: "America/New_York", label: "New York (ET)" },
            { value: "America/Toronto", label: "Toronto (ET)" },
            { value: "America/Vancouver", label: "Vancouver (PT)" },
        ],
    },
    {
        region: "Latin America",
        zones: [
            { value: "America/Mexico_City", label: "Mexico City (CST)" },
            { value: "America/Bogota", label: "Bogotá (COT)" },
            { value: "America/Sao_Paulo", label: "São Paulo (BRT)" },
            { value: "America/Argentina/Buenos_Aires", label: "Buenos Aires (ART)" },
        ],
    },
    {
        region: "Europe",
        zones: [
            { value: "Europe/London", label: "London (GMT/BST)" },
            { value: "Europe/Dublin", label: "Dublin (GMT/IST)" },
            { value: "Europe/Lisbon", label: "Lisbon (WET)" },
            { value: "Europe/Madrid", label: "Madrid (CET)" },
            { value: "Europe/Paris", label: "Paris (CET)" },
            { value: "Europe/Amsterdam", label: "Amsterdam (CET)" },
            { value: "Europe/Berlin", label: "Berlin (CET)" },
            { value: "Europe/Zurich", label: "Zurich (CET)" },
            { value: "Europe/Rome", label: "Rome (CET)" },
            { value: "Europe/Stockholm", label: "Stockholm (CET)" },
            { value: "Europe/Warsaw", label: "Warsaw (CET)" },
            { value: "Europe/Helsinki", label: "Helsinki (EET)" },
            { value: "Europe/Athens", label: "Athens (EET)" },
        ],
    },
    {
        region: "EMEA (Middle East & Africa)",
        zones: [
            { value: "Europe/Istanbul", label: "Istanbul (TRT)" },
            { value: "Africa/Cairo", label: "Cairo (EET)" },
            { value: "Africa/Johannesburg", label: "Johannesburg (SAST)" },
            { value: "Africa/Lagos", label: "Lagos (WAT)" },
            { value: "Africa/Nairobi", label: "Nairobi (EAT)" },
            { value: "Asia/Jerusalem", label: "Jerusalem (IST)" },
            { value: "Asia/Riyadh", label: "Riyadh (AST)" },
            { value: "Asia/Dubai", label: "Dubai (GST)" },
        ],
    },
    {
        region: "APAC (Asia)",
        zones: [
            { value: "Asia/Karachi", label: "Karachi (PKT)" },
            { value: "Asia/Kolkata", label: "Mumbai / Delhi (IST)" },
            { value: "Asia/Dhaka", label: "Dhaka (BDT)" },
            { value: "Asia/Bangkok", label: "Bangkok (ICT)" },
            { value: "Asia/Jakarta", label: "Jakarta (WIB)" },
            { value: "Asia/Singapore", label: "Singapore (SGT)" },
            { value: "Asia/Hong_Kong", label: "Hong Kong (HKT)" },
            { value: "Asia/Shanghai", label: "Shanghai / Beijing (CST)" },
            { value: "Asia/Taipei", label: "Taipei (CST)" },
            { value: "Asia/Seoul", label: "Seoul (KST)" },
            { value: "Asia/Tokyo", label: "Tokyo (JST)" },
        ],
    },
    {
        region: "ANZ (Australia & NZ)",
        zones: [
            { value: "Australia/Perth", label: "Perth (AWST)" },
            { value: "Australia/Adelaide", label: "Adelaide (ACST/ACDT)" },
            { value: "Australia/Brisbane", label: "Brisbane (AEST)" },
            { value: "Australia/Sydney", label: "Sydney / Melbourne (AEST/AEDT)" },
            { value: "Pacific/Auckland", label: "Auckland (NZST/NZDT)" },
        ],
    },
];

export const flatTimezones = () =>
    TIMEZONE_GROUPS.flatMap((g) => g.zones.map((z) => ({ ...z, region: g.region })));
